import * as analytics from './analytics';
export default analytics;
